import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AvailableTariff, AvailableTariffsData, DopTariff } from '@src/store/ducks/tariffs/types'

export const initialState = {
  freeBlockDays: 0,
  isLoadingBlock: false,
  isSuccessBlock: false,
  dopTariffs: [] as DopTariff[],
  availableTariff: [] as AvailableTariffsData[],
  blockTariffs: [] as AvailableTariff[],
  isLoading: false,
  isLoadingChangeTariff: false,
  isSuccessChangeTariff: false,
  tariffInfo: [] as any,
  error: false,
  blockDescription: '',
}
const tariffsSlice = createSlice({
  name: 'tariffs',
  initialState,
  reducers: {
    setFreeBlockDays(state, { payload }: PayloadAction<number>) {
      state.freeBlockDays = payload
    },
    setIsLoadingBlock(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingBlock = payload
    },
    setIsSuccessBlock(state, { payload }: PayloadAction<boolean>) {
      state.isSuccessBlock = payload
    },
    setDopTariffs(state, { payload }: PayloadAction<DopTariff[]>) {
      state.dopTariffs = payload
    },
    setAvailableTariffs(state, { payload }: PayloadAction<AvailableTariffsData[]>) {
      state.availableTariff = payload
    },
    setIsLoading(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload
    },
    setIsLoadingChangeTariff(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingChangeTariff = payload
    },
    setIsSuccessChangeTariff(state, { payload }: PayloadAction<boolean>) {
      state.isSuccessChangeTariff = payload
    },
    setError(state, { payload }: PayloadAction<boolean>) {
      state.error = payload
    },
    setTariffInfo(state, { payload }: PayloadAction<any>) {
      state.tariffInfo = payload
    },
    setBlockTariffs(state, { payload }: PayloadAction<AvailableTariff[]>) {
      state.blockTariffs = payload
    },
    setBlockDescription(state, { payload }: PayloadAction<string>) {
      state.blockDescription = payload
    },
    resetTariffs: () => initialState,
  },
})
export type TariffsStateType = typeof initialState

export const {
  setFreeBlockDays,
  setIsLoadingBlock,
  setIsSuccessBlock,
  setDopTariffs,
  setIsLoading,
  setAvailableTariffs,
  setIsLoadingChangeTariff,
  setIsSuccessChangeTariff,
  setTariffInfo,
  setBlockTariffs,
  resetTariffs,
  setBlockDescription,
  setError,
} = tariffsSlice.actions
export const tariffsReducer = tariffsSlice.reducer
